import { LOAD_ANALYTICS_DATA_START, LOAD_ANALYTICS_DATA_SUCCESS, LOAD_ANALYTICS_DATA_ERROR } from "./actions";

// Initial state
const initialState = {
    growth: [],
    botActivity: [],
    loading: false,
    error: null,
};

// Reducer function
export const analytics = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_ANALYTICS_DATA_START:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case LOAD_ANALYTICS_DATA_SUCCESS:
            return {
                ...state,
                growth: action.payload.growth,
                botActivity: action.payload.botActivity,
                loading: false,
                error: null,
            };
        case LOAD_ANALYTICS_DATA_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

